import Axios from 'axios';

const bp = '/bp';

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('Token')}`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

const handleError = (error, success) => {
  success(error.response || error);
};

// ── Checklist Item — shared flat pool ────────────────────────────────────

export const ci_list = (success) =>
  Axios.get(`${bp}/checklist-item/list/`, { headers: getHeaders() })
    .then(success)
    .catch((e) => handleError(e, success));

export const ci_create = async (data, success) => {
  try {
    const res = await Axios.post(`${bp}/checklist-item/create/`, data, { headers: getHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};

// ── Checklist Field — named group referencing item IDs ───────────────────

export const cf_list = (success) =>
  Axios.get(`${bp}/checklist-field/list/`, { headers: getHeaders() })
    .then(success)
    .catch((e) => handleError(e, success));

export const cf_create = async (data, success) => {
  try {
    const res = await Axios.post(`${bp}/checklist-field/create/`, data, { headers: getHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};

export const cf_update = async (id, data, success) => {
  try {
    const res = await Axios.put(`${bp}/checklist-field/update/${id}/`, data, { headers: getHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};
